import { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const AuthCallback = () => {
  const processed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState({}, "", "/dashboard");
        window.location.replace("/dashboard");
      } catch {
        window.location.replace("/login");
      }
    })();
  }, [setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-background" data-testid="auth-callback">
      <p className="text-sm text-muted-foreground">Signing you in…</p>
    </div>
  );
};

export default AuthCallback;
